var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        absolute: "",
        right: "",
        shaped: "",
        top: "",
        "max-width": "200px",
        timeout: _vm.timeout,
        value: _vm.value.visible,
        color: _vm.value.color,
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.value.text) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/bot/snackbar/bot.snackbar.vue